module.exports = __webpack_public_path__ + "img/hero-building-a.47c51dc5.jpg";